<template>
  <v-popover v-if="isDebugMode" classes="tooltip-bubble">
    <b-icon icon="bug" />
    <template slot="popover">
      <router-link
        class="next-btn pure-material-button-contained"
        :to="{ name: 'ProjectObject', params: { _id: this.object._id } }"
      >
        <b-icon icon="eye-fill" />
      </router-link>
      <b-icon v-close-popover icon="x" />
      <ProjectObjectItem :object="object" :level="0" />
    </template>
  </v-popover>
</template>

<script>
import { mapGetters } from 'vuex';
import ProjectObjectItem from '@/components/projectoverview/ProjectObjectItem.vue';

export default {
  name: 'Debug',
  props: {
    object: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters(['isDebugMode']),
  },
  components: {
    ProjectObjectItem,
  },
};
</script>

<style scoped>
.v-popover {
  display: inline;
}

.debug {
  white-space: nowrap;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/toolbar/Debug.vue